import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SessionTimeOutComponent } from '../components/session-time-out/session-time-out.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '../services/config/config.service';
import { environment } from '../../../../environments/environment';

export const httpRequestInterceptor: HttpInterceptorFn = (
	request: HttpRequest<any>,
	next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
	const configService = inject(ConfigService)
	const dialog = inject(MatDialog)

	// Add headers to mark this as an AJAX request
	let headers = request.headers.append('X-Requested-With', 'XMLHttpRequest')

	// Add entity information if available
	if (configService.config.hasConnectedUser()) {
		headers = headers.append('X-Entity-With', configService.config.getEntityHeader())
	} else {
		const params = new URLSearchParams(window.location.search)
		const entityParam = params.get('X-Entity-With')
		if (entityParam) {
			headers = headers.append('X-Entity-With', entityParam)
		}
	}

	// Modify the URL if it is not a static resource
	let modPath = environment.http_request_path
	if (request.url.startsWith('assets') ||	request.url.startsWith('http') || request.responseType === 'arraybuffer') {
		modPath = ''
	}

	const clonedRequest = request.clone({ headers, url: modPath + request.url })

	return next(clonedRequest).pipe(
		tap({
			error: (error: HttpErrorResponse) => {
				const status = error.status

				// Handle specific error codes
				if ([666, 667, 502, 504].includes(status)) {
					console.log('----response----')
					console.error('status code:', status)
					console.error(error.message)
					console.log('--- end of response---')

					setTimeout(() => {
						console.log('Reload page is needed!!!')

						const alreadyOpened = dialog.openDialogs.some(
							d => d.componentInstance instanceof SessionTimeOutComponent
						)

						if (alreadyOpened) 
							return

						dialog.open(SessionTimeOutComponent, {
							position: { top: '40px' },
							hasBackdrop: true,
							panelClass: 'no-dialog-borders',
							disableClose: true,
							data: { code: status }
						}).afterClosed().subscribe()
					}, 10)
				}
			}
		})
	)
}
